import React from 'react';

function SubscribeForm({ size, children }) {
  return (
    <form className={`subscribe-${size}-form`}>
      <hr className={`subscribe-${size}-border`} />
      {children}
    </form>
  );
}

export default SubscribeForm;
